import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ConfigProvider } from 'antd';
import { globalStyles } from './utils/theme';
import faceIO from "@faceio/fiojs"

//GLOBAL VARIABLES
window.$company_name = "Hungry Hailey Corporation";
window.$company_address = "#205B One Paseo, Paseo Saturnino, Banilad, Cebu City, Cebu, 6000";
window.$faceioInstance = new faceIO("fioa5dab");
window.$company_phic_no = "";
window.$company_tin = "649-093-559-000";
window.$company_sss_no = "";
window.$company_employer_type = "";
window.$company_hr = "COMPANY HR";
window.$company_ceo = "COMPANY CEO";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary:   globalStyles.colorPrimary,
          colorSuccess:   globalStyles.colorSuccess,
          colorWarning:   globalStyles.colorWarning,
          colorTextBase:  globalStyles.colorTextBase,

          fontFamily  :   globalStyles.fontRegular
      }}}
    >
      <App />
    </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
